import { useEffect, useState } from "react";
import withLoader from "../../components/layouts/WithLoader"
import Banque from "../../services/Banque";
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";


const localizer = momentLocalizer(moment);


// const CustomToolbar = ({ label, onNavigate, onView }) => (
//     <div className="row">
//         <div className="col-sm-5">

           
//             <div className="btn-group btn-group-toggle" data-toggle="buttons">
//                 <button  type="button"  className="btn btn-default" onClick={(e) =>{ onNavigate('PREV')}}>Previous</button>
//                 <button  type="button"  className="btn btn-default" onClick={(e) =>{ onNavigate('NEXT')}}>Next</button>
//             </div>
//         </div>
//         <div className="col-sm-7">
//             <h2>{label}</h2>
//         </div>
//         <br />
//     </div>
// );

const CustomToolbar = ({ label, onNavigate }) => {
  return (
    <div className="rbc-toolbar">
      {/* Navigation Buttons */}
      <div className="btn-group">
        <button
          type="button"
          className="btn btn-light"
          onClick={() => onNavigate('PREV')}
        >
          ‹ Previous
        </button>
        {/* <button
          type="button"
          className="btn btn-light mx-1"
          onClick={() => onNavigate('TODAY')}
        >
          Today
        </button> */}
        <button
          type="button"
          className="btn btn-light"
          onClick={() => onNavigate('NEXT')}
        >
          Next ›
        </button>
      </div>

      {/* Month/Year Label (Centered) */}
      <div className="rbc-toolbar-label">
        <h4 className="mb-0">{label}</h4>
      </div>
    </div>
  );
};


const PayementAgendaAllAccounts =({startLoading,stopLoading})=>{
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [events, setEvents] = useState([]);
        const [achat, setAchat] = useState(0);
        const [vente, setVente] = useState(0);


    useEffect(() => {
        const startDate = moment(selectedDate).startOf('month').toISOString();
        const endDate = moment(selectedDate).endOf('month').toISOString();
    setAchat(0);
                setVente(0);
        console.log("startDate", startDate)
        console.log("endDate", endDate)


        startLoading();
        Banque.getAllEcheance(getCurrentUserId(), startDate, endDate).then((response) => {

            if (response.data.success) {
                setEvents(response.data.success);
                setAchat(response.data.achat);
                setVente(response.data.vente);

            }
        }).catch((error) => { }).finally(() => {
            stopLoading();
        });

    }, [selectedDate])

    const ColoredEvent = ({ event}) => {
        return (
          <div
            style={{
              backgroundColor: event.backgroundColor,
              borderColor:event.backgroundColor,
              borderRadius: '5px',
              padding: '2px',
              cursor: 'pointer',
            }}
          >
            {event?.title}
          </div>
        );

    }
    return (
        <div class="content-wrapper" style={{ marginTop: "0" }}>
        <br/>
         <section class="content">

                <div className="row">
                    <div className=" col-md-4"></div>
                    <div className="info-box bg-success col-md-2 col-sm-5 col-12 m-2">
                        <span className="info-box-icon">
                            <i class="fas fa-money-bill"></i>

                        </span>
                        <div className="info-box-content">
                            <span className="info-box-text">Vente</span>
                            <span className="info-box-number">{vente}</span>
                            <div className="progress">
                                <div className="progress-bar" style={{ width: "70%" }}></div>
                            </div>

                        </div>
                    </div>

                    <div className="info-box bg-danger col-md-2 col-sm-5 col-12 m-2">
                        <span className="info-box-icon">
                            <i class="fas fa-money-bill"></i>
                        </span>
                        <div className="info-box-content">
                            <span className="info-box-text">Achat</span>
                            <span className="info-box-number">{achat}</span>
                            <div className="progress">
                                <div className="progress-bar" style={{ width: "70%" }}></div>
                            </div>
                        </div>
                    </div>
                </div>


            </section>
           
            <section class="content">
                <div class="row">
                    <div class="col-md-12">
                        <div className="card ">
                            <div className="card-body">
                                <Calendar
                                    localizer={localizer}
                                    events={events }
                                    startAccessor="start"
                                    endAccessor="end"
                                    defaultDate={selectedDate}
                                    views={['month', 'agenda']}
                                    style={{ height: 500 }}

                                    components={{
                                        toolbar: CustomToolbar,
                                        eventWrapper: ColoredEvent,
                                       
                                    }}
                                    onNavigate={(date, view) => {
                                        if (view === 'month') {
                                            setSelectedDate(date);
                                        }
                                    }}
                                    popup

                                />

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );




}
export default withLoader(PayementAgendaAllAccounts)